export default "__VITE_ASSET__330b4398__"